import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-password-fields',
  templateUrl: './password-fields.component.html',
  styleUrls: ['./password-fields.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, IonicModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordFieldsComponent),
      multi: true
    }
  ]
})
export class PasswordFieldsComponent implements ControlValueAccessor {
  @Input() submitted: boolean = false;
  
  textType = "password";

  passwordForm: FormGroup = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(6)]],
    password_confirmation: ['', [Validators.required, this.confirmPassword()]]
  });

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(private fb: FormBuilder) {
    this.passwordForm.valueChanges.subscribe(value => {
      this.onChange(value);
    });
  }

  confirmPassword(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const passwordConfirm = control.value;
      const password = this.passwordForm?.get('password')?.value;
      
      if (password === passwordConfirm) {
        return null;
      } else if (passwordConfirm && passwordConfirm.length > 0 && password !== passwordConfirm) {
        return { password_mismatch: true };
      } else {
        return { password_mismatch: false };
      }
    };
  }

  togglePasswordVisibility() {
    this.textType = this.textType === "text" ? "password" : "text";
  }

  writeValue(value: any): void {
    if (value) {
      this.passwordForm.patchValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.passwordForm.disable();
    } else {
      this.passwordForm.enable();
    }
  }

  get passwordControl() {
    return this.passwordForm.get('password');
  }

  get passwordConfirmControl() {
    return this.passwordForm.get('password_confirmation');
  }
}
